/*
  assets/gtender-workspace-saved.js — GTENDER-WORKSPACE-FE-WS02
  Owner: GTender Pro Saved workspace panel only.
  Identity / plan authority remains LittleGWebSession -> Core -> gtender_account.
  Saved persistence remains native-subject scoped behind /v1/tender/saved.
  Cross-capability actions emit workspace intent only; Pipeline persistence stays with its own owner.
*/
(function () {
  'use strict';

  var VERSION = 'gtender-workspace-fe-ws02-02';
  var GLOBAL_KEY = '__GTENDER_WORKSPACE_SAVED_RUNTIME__';
  var ROOT_SELECTOR = '[data-gtender-dashboard-root][data-native-session-required]';
  var API_ORIGIN = 'https://api.glhksolution.com';
  var SAVED_URL = API_ORIGIN + '/v1/tender/saved';
  var REQUEST_TIMEOUT_MS = 10000;
  var stateByRoot = new WeakMap();
  var ZH_CN = Object.freeze({
    '正在重新核驗 GTender Pro 權限…': '正在重新核验 GTender Pro 权限…',
    '尚未有雲端收藏': '尚未有云端收藏',
    '從公開 GTender 保存招標後，會在這裡顯示。': '从公开 GTender 保存招标后，会在这里显示。',
    '已保存': '已保存',
    '資料暫時不可用': '数据暂时不可用',
    '詳情': '详情',
    '移除': '移除',
    '加入 Pipeline': '加入 Pipeline',
    'Saved ownership 尚未完成遷移': 'Saved ownership 尚未完成迁移',
    'Saved 暫時無法載入': 'Saved 暂时无法载入',
    '不會將 legacy customer-owned Saved 推定為目前 native subject。': '不会将 legacy customer-owned Saved 推定为当前 native subject。',
    '現有 Saved 資料保持不變。': '现有 Saved 数据保持不变。',
    '正在載入 Saved…': '正在载入 Saved…',
    '未進行 ownership 推定。': '未进行 ownership 推定。',
    '沒有修改已儲存資料': '未修改任何 Saved 数据。',
    '已載入 native Pro Saved。': '已载入 native Pro Saved。',
    '正在移除…': '正在移除…',
    '未能移除；Saved 保持不變。': '未能移除；Saved 保持不变。',
    '已從 Saved 移除。': '已从 Saved 移除。',
    '雲端收藏': '云端收藏',
    'Saved 只會載入目前已驗證 native Pro 帳戶的資料。': 'Saved 只会载入当前已验证 native Pro 账户的数据。',
    '重新載入': '重新载入'
  });

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].boot === 'function') {
    window[GLOBAL_KEY].boot(document);
    return;
  }

  function list(scope, selector) {
    var target = scope || document;
    var output = [];
    if (target.matches && target.matches(selector)) output.push(target);
    if (target.querySelectorAll) Array.prototype.push.apply(output, target.querySelectorAll(selector));
    return output;
  }

  function clean(value) { return String(value == null ? '' : value).trim(); }
  function localeFamily(root) {
    var locale = clean(root && root.getAttribute('data-locale')) || clean(document.documentElement.lang) || 'en';
    locale = locale.toLowerCase();
    if (locale === 'zh-cn' || locale === 'zh-hans' || locale === 'zh-sg') return 'zh-CN';
    if (locale.indexOf('zh') === 0) return 'zh-TW';
    return 'en';
  }
  function copy(root, zh, en) {
    var family = localeFamily(root);
    if (family === 'zh-CN') return ZH_CN[zh] || zh;
    return family === 'zh-TW' ? zh : en;
  }
  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
  }
  function workspace() {
    return window.GTenderWorkspace && typeof window.GTenderWorkspace.getPanelHost === 'function' ? window.GTenderWorkspace : null;
  }

  function requestJson(root, state, url, options) {
    var session = window.LittleGWebSession;
    if (!session || typeof session.authenticatedFetch !== 'function') {
      return Promise.resolve({ ok: false, status: 0, code: 'native_session_unavailable', data: {} });
    }
    if (state.requestController) state.requestController.abort();
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    state.requestController = controller;
    var requestOptions = Object.assign({}, options || {});
    requestOptions.headers = Object.assign({ Accept: 'application/json' }, requestOptions.headers || {});
    if (controller) requestOptions.signal = controller.signal;
    var timeout = null;
    var deadline = new Promise(function (_, reject) {
      timeout = window.setTimeout(function () {
        if (controller) controller.abort();
        var error = new Error('GTender Saved request timed out.');
        error.code = 'gtender_saved_timeout';
        reject(error);
      }, REQUEST_TIMEOUT_MS);
    });
    return Promise.race([session.authenticatedFetch(url, requestOptions), deadline]).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        return {
          ok: response.ok && payload && payload.success === true,
          status: response.status,
          code: clean(payload && payload.error && payload.error.code),
          data: payload && payload.data && typeof payload.data === 'object' ? payload.data : {}
        };
      });
    }).catch(function (error) {
      return { ok: false, status: 0, code: clean(error && error.code) || 'network_error', data: {} };
    }).finally(function () {
      if (timeout !== null) window.clearTimeout(timeout);
      if (state.requestController === controller) state.requestController = null;
    });
  }

  function setStatus(state, text, tone) {
    state.status.textContent = text || '';
    state.status.setAttribute('data-tone', tone || 'neutral');
  }

  function accessChanged(root, state) {
    var ws = workspace();
    if (ws) ws.disable(root, 'saved');
    state.loaded = false;
    state.items = [];
    setStatus(state, copy(root, '正在重新核驗 GTender Pro 權限…', 'Revalidating GTender Pro access…'), 'warning');
    root.dispatchEvent(new CustomEvent('gtender-dashboard:access-refresh-required', { bubbles: true }));
  }

  function title(item) {
    var tender = item && item.tender && typeof item.tender === 'object' ? item.tender : {};
    return clean(tender.title || tender.subject_en || tender.subject_zh_hk || tender.tender_reference || item && item.tender_id);
  }

  function emitPipelineIntent(root, tenderId) {
    root.dispatchEvent(new CustomEvent('gtender-workspace:pipeline-add', {
      bubbles: true,
      detail: { tender_id: clean(tenderId), stage: 'watching', source: 'saved' }
    }));
  }

  function render(root, state) {
    state.list.replaceChildren();
    state.count.textContent = String(state.items.length);
    if (!state.items.length) {
      var empty = element('div', 'gtender-workspace-saved__empty');
      empty.appendChild(element('h3', '', copy(root, '尚未有雲端收藏', 'No cloud saves yet')));
      empty.appendChild(element('p', '', copy(root, '從公開 GTender 保存招標後，會在這裡顯示。', 'Save a tender from public GTender and it will appear here.')));
      state.list.appendChild(empty);
      return;
    }

    state.items.forEach(function (item) {
      var id = clean(item && item.tender_id);
      if (!id) return;
      var card = element('article', 'gtender-workspace-saved__item');
      card.setAttribute('data-gtender-saved-item', id);
      var head = element('div', 'gtender-workspace-saved__head');
      var copyNode = element('div', '');
      copyNode.appendChild(element('strong', '', title(item) || id));
      copyNode.appendChild(element('p', '', copy(root, '已保存', 'Saved')));
      head.appendChild(copyNode);
      var remove = element('button', 'gtender-workspace-saved__button gtender-workspace-saved__button--danger', copy(root, '移除', 'Remove'));
      remove.type = 'button';
      remove.setAttribute('data-gtender-saved-delete', id);
      head.appendChild(remove);
      card.appendChild(head);

      var actions = element('div', 'gtender-workspace-saved__actions');
      var addPipeline = element('button', 'gtender-workspace-saved__button', copy(root, '加入 Pipeline', 'Add to Pipeline'));
      addPipeline.type = 'button';
      addPipeline.setAttribute('data-gtender-saved-add-pipeline', id);
      actions.appendChild(addPipeline);

      var open = element('button', 'gtender-workspace-saved__button', copy(root, '詳情', 'Details'));
      open.type = 'button';
      open.setAttribute('data-gtender-saved-open', id);
      actions.appendChild(open);
      card.appendChild(actions);

      var error = element('p', 'gtender-workspace-saved__row-error', '');
      error.setAttribute('data-gtender-saved-row-error', id);
      error.setAttribute('aria-live', 'polite');
      card.appendChild(error);
      state.list.appendChild(card);
    });
  }

  function renderBlocked(root, state, migration) {
    state.list.replaceChildren();
    var box = element('div', 'gtender-workspace-saved__empty');
    box.appendChild(element('h3', '', migration
      ? copy(root, 'Saved ownership 尚未完成遷移', 'Saved ownership migration is pending')
      : copy(root, 'Saved 暫時無法載入', 'Saved is temporarily unavailable')));
    box.appendChild(element('p', '', migration
      ? copy(root, '不會將 legacy customer-owned Saved 推定為目前 native subject。', 'Legacy customer-owned Saved is not assumed to belong to the current native subject.')
      : copy(root, '現有 Saved 資料保持不變。', 'Existing Saved data remains unchanged.')));
    state.list.appendChild(box);
    state.count.textContent = '—';
  }

  function load(root, state, force) {
    if (!state.active || root.getAttribute('data-access-state') !== 'pro') return Promise.resolve(false);
    if (state.loading) return Promise.resolve(false);
    if (state.loaded && !force) return Promise.resolve(true);
    state.loading = true;
    root.setAttribute('data-saved-workspace-state', 'loading');
    setStatus(state, copy(root, '正在載入 Saved…', 'Loading Saved…'), 'neutral');
    return requestJson(root, state, SAVED_URL + '?limit=200', { method: 'GET' }).then(function (result) {
      if (!state.active || root.getAttribute('data-access-state') !== 'pro') return false;
      if (result.status === 401 || result.status === 403) {
        accessChanged(root, state);
        root.setAttribute('data-saved-workspace-state', 'access-changed');
        return false;
      }
      if (result.status === 409 && result.code === 'workspace_ownership_migration_required') {
        state.loaded = false;
        renderBlocked(root, state, true);
        setStatus(state, copy(root, '未進行 ownership 推定。', 'No ownership assumption was made.'), 'warning');
        root.setAttribute('data-saved-workspace-state', 'ownership-blocked');
        return false;
      }
      if (!result.ok || !Array.isArray(result.data.items)) {
        state.loaded = false;
        renderBlocked(root, state, false);
        setStatus(state, copy(root, '沒有修改已儲存資料', 'No data was changed.'), 'warning');
        root.setAttribute('data-saved-workspace-state', 'unavailable');
        return false;
      }
      state.items = result.data.items.filter(function (item) { return clean(item && item.tender_id); }).slice(0, 200);
      state.loaded = true;
      render(root, state);
      setStatus(state, copy(root, '已載入 native Pro Saved。', 'Native Pro Saved loaded.'), 'success');
      root.setAttribute('data-saved-workspace-state', 'ready');
      return true;
    }).finally(function () { state.loading = false; });
  }

  function rowError(state, id, text) {
    var node = state.host.querySelector('[data-gtender-saved-row-error="' + CSS.escape(id) + '"]');
    if (node) node.textContent = text || '';
  }

  function deleteItem(root, state, id, button) {
    if (!id || state.deleting.has(id)) return;
    state.deleting.add(id);
    button.disabled = true;
    rowError(state, id, copy(root, '正在移除…', 'Removing…'));
    requestJson(root, state, SAVED_URL + '/' + encodeURIComponent(id), { method: 'DELETE' }).then(function (result) {
      if (result.status === 401 || result.status === 403) return accessChanged(root, state);
      if (!result.ok || result.data.deleted !== true) {
        rowError(state, id, copy(root, '未能移除；Saved 保持不變。', 'Remove failed; Saved is unchanged.'));
        return;
      }
      state.items = state.items.filter(function (item) { return clean(item.tender_id) !== id; });
      render(root, state);
      setStatus(state, copy(root, '已從 Saved 移除。', 'Removed from Saved.'), 'success');
    }).finally(function () {
      state.deleting.delete(id);
      if (button.isConnected) button.disabled = false;
    });
  }

  function openTender(root, id) {
    try {
      var url = new URL(root.getAttribute('data-radar-url') || '/pages/gtender', window.location.origin);
      url.searchParams.set('tender', id);
      window.open(url.toString(), '_blank', 'noopener,noreferrer');
    } catch (_error) {}
  }

  function makeShell(root, host) {
    host.replaceChildren();
    var shell = element('div', 'gtender-workspace-saved');
    shell.setAttribute('data-gtender-workspace-saved', '');
    var header = element('div', 'gtender-workspace-saved__header');
    var copyNode = element('div', '');
    copyNode.appendChild(element('p', 'gtender-workspace-saved__eyebrow', 'GTender Pro'));
    copyNode.appendChild(element('h2', '', copy(root, '雲端收藏', 'Cloud Saved')));
    copyNode.appendChild(element('p', '', copy(root, 'Saved 只會載入目前已驗證 native Pro 帳戶的資料。', 'Saved loads only from the currently verified native Pro account.')));
    header.appendChild(copyNode);
    var count = element('strong', 'gtender-workspace-saved__count', '—');
    header.appendChild(count);
    shell.appendChild(header);
    var status = element('p', 'gtender-workspace-saved__status', '');
    status.setAttribute('aria-live', 'polite');
    shell.appendChild(status);
    var toolbar = element('div', 'gtender-workspace-saved__toolbar');
    var refresh = element('button', 'gtender-workspace-saved__button', copy(root, '重新載入', 'Refresh'));
    refresh.type = 'button';
    refresh.setAttribute('data-gtender-saved-refresh', '');
    toolbar.appendChild(refresh);
    shell.appendChild(toolbar);
    var listNode = element('div', 'gtender-workspace-saved__list');
    shell.appendChild(listNode);
    host.appendChild(shell);
    return { shell: shell, count: count, status: status, list: listNode };
  }

  function activate(root, state) {
    var ws = workspace();
    if (!ws || root.getAttribute('data-access-state') !== 'pro') return;
    ws.enable(root, 'saved');
    if (root.getAttribute('data-workspace-tab') === 'saved') load(root, state, false);
  }

  function invalidate(root, state) {
    state.loaded = false;
    state.items = [];
    if (state.requestController) state.requestController.abort();
    var ws = workspace();
    if (ws) ws.disable(root, 'saved');
    state.list.replaceChildren();
    state.count.textContent = '—';
    setStatus(state, '', 'neutral');
    root.removeAttribute('data-saved-workspace-state');
  }

  function mount(root) {
    if (!root || stateByRoot.has(root)) return;
    var ws = workspace();
    if (!ws) return;
    var host = ws.getPanelHost(root, 'saved');
    if (!host) return;
    var ui = makeShell(root, host);
    var state = {
      active: true,
      controller: new AbortController(),
      requestController: null,
      host: host,
      shell: ui.shell,
      count: ui.count,
      status: ui.status,
      list: ui.list,
      items: [],
      loaded: false,
      loading: false,
      deleting: new Set()
    };
    stateByRoot.set(root, state);
    root.setAttribute('data-saved-workspace-owner', VERSION);

    state.shell.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('button') : null;
      if (!target || !state.host.contains(target)) return;
      if (target.matches('[data-gtender-saved-refresh]')) { event.preventDefault(); state.loaded = false; load(root, state, true); return; }
      var pipelineId = clean(target.getAttribute('data-gtender-saved-add-pipeline'));
      if (pipelineId) { event.preventDefault(); emitPipelineIntent(root, pipelineId); return; }
      var id = clean(target.getAttribute('data-gtender-saved-delete'));
      if (id) { event.preventDefault(); deleteItem(root, state, id, target); return; }
      id = clean(target.getAttribute('data-gtender-saved-open'));
      if (id) { event.preventDefault(); openTender(root, id); }
    }, { signal: state.controller.signal });
    root.addEventListener('gtender-dashboard:pro-ready', function () { activate(root, state); }, { signal: state.controller.signal });
    root.addEventListener('gtender-dashboard:access-invalidated', function () { invalidate(root, state); }, { signal: state.controller.signal });
    root.addEventListener('gtender-workspace:tabchange', function (event) {
      if (event && event.detail && event.detail.tab === 'saved') load(root, state, false);
    }, { signal: state.controller.signal });
    root.addEventListener('gtender:cloud-save:changed', function (event) {
      if (event && event.detail && event.detail.saved === true) { state.loaded = false; if (root.getAttribute('data-workspace-tab') === 'saved') load(root, state, true); }
    }, { signal: state.controller.signal });
    activate(root, state);
  }

  function destroy(root) {
    var state = root ? stateByRoot.get(root) : null;
    if (!state) return;
    state.active = false;
    if (state.requestController) state.requestController.abort();
    state.controller.abort();
    var ws = workspace();
    if (ws) ws.disable(root, 'saved');
    state.host.replaceChildren();
    root.removeAttribute('data-saved-workspace-owner');
    root.removeAttribute('data-saved-workspace-state');
    stateByRoot.delete(root);
  }

  function boot(scope) {
    var target = scope || document;
    list(target, ROOT_SELECTOR).forEach(mount);
  }

  function destroyAll(scope) {
    var target = scope || document;
    list(target, ROOT_SELECTOR).forEach(destroy);
  }

  document.addEventListener('shopify:section:load', function () { window.setTimeout(function () { boot(document); }, 0); });
  document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target || document); });
  window.addEventListener('pageshow', function () { boot(document); });

  var api = Object.freeze({ version: VERSION, boot: boot, destroy: destroyAll, load: load });
  window[GLOBAL_KEY] = api;
  window.GTenderWorkspaceSaved = api;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
})();
